import { Tile, isTerminalOrHonor, tileNumber } from '../tiles';
import { Group, StandardParse } from '../decompose';
import { WinContext, YakuResult } from './yaku';

export interface FuInput {
  parse: StandardParse;
  ctx: WinContext;
  yaku: YakuResult[];
  isConcealed: boolean; // Phase 1: 항상 true
}

export function computeChiitoitsuFu(): number { return 25; }

const DRAGONS = [31, 32, 33];

function seqTiles(g: Group): Tile[] { return [g.tile, g.tile + 1, g.tile + 2]; }

/** 표준형 분해의 후(符). 10단위 올림. */
export function computeFu(input: FuInput): number {
  const { parse, ctx, yaku } = input;
  const isPinfu = yaku.some((y) => y.key === 'pinfu');

  // 핑후 예외
  if (isPinfu) return ctx.isTsumo ? 20 : 30; // 핑후쯔모 20, 핑후론(멘젠) 30

  let fu = 20; // 기본부(후테이)

  // 멘젠 론 가산
  if (input.isConcealed && !ctx.isTsumo) fu += 10;
  // 쯔모 가산 (핑후는 위에서 처리됨)
  if (ctx.isTsumo) fu += 2;

  const melds = parse.groups.filter((g) => g.type !== 'pair');
  const pair = parse.groups.find((g) => g.type === 'pair')!;

  // 면자 후
  for (const g of melds) {
    if (g.type === 'shuntsu') continue; // 슌쯔 0부
    // 커쯔: 화료패가 이 커쯔를 론으로 완성했으면 명각 취급
    const completedByRon = !ctx.isTsumo && g.tile === ctx.winningTile;
    const terminalHonor = isTerminalOrHonor(g.tile);
    let base: number;
    if (completedByRon) base = terminalHonor ? 4 : 2; // 명각
    else base = terminalHonor ? 8 : 4;                 // 암각
    fu += base;
  }

  // 작두(役패) 가산
  if (DRAGONS.includes(pair.tile)) fu += 2;
  if (pair.tile === ctx.seatWind) fu += 2;
  if (pair.tile === ctx.roundWind) fu += 2; // 연풍(자=장)이면 +2씩 누적(=4)

  // 대기 가산: 단기/칸짱/변짱 +2
  fu += waitFu(parse, ctx.winningTile);

  // 10단위 올림
  return Math.ceil(fu / 10) * 10;
}

/** 대기 형태에 따른 후 가산(단기/칸짱/변짱 = 2, 양면/쌍퐁 = 0).
 *  화료패가 어떤 그룹을 완성했는지로 판정. 여러 해석 가능하면 큰 값(2) 우선은 하지 않고
 *  가장 흔한 단일 해석을 적용: 작두==화료패→단기, 슌쯔 중앙→칸짱, 변짱(123 대기 3 / 789 대기 7)→2, 그 외 0. */
function waitFu(parse: StandardParse, w: Tile): number {
  const pair = parse.groups.find((g) => g.type === 'pair')!;
  if (pair.tile === w) return 2; // 단기(탄키)

  for (const g of parse.groups) {
    if (g.type !== 'shuntsu') continue;
    const [a, b, c] = seqTiles(g);
    if (w === b) return 2; // 칸짱(중앙)
    // 변짱: 123에서 3대기(a의 숫자==1, w==c) 또는 789에서 7대기(c의 숫자==9, w==a)
    if (w === c && tileNumber(a) === 1) return 2;
    if (w === a && tileNumber(c) === 9) return 2;
  }
  return 0; // 양면/쌍퐁
}
